export function downloadBase64(base64, name) {
    var ismsie = !!window.ActiveXObject || 'ActiveXObject' in window;
    var isedge = navigator.userAgent.indexOf('Edge') > -1;
    var a = document.createElement('a');
    a.href = base64;
    a.download = name || document.title;
    a.target = '_blank';
    // for Chrome and Firefox
    if (typeof MouseEvent === 'function' && !(ismsie || isedge)) {
        var evt = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: false,
        });
        a.dispatchEvent(evt);
    }
    else {
        // for IE
        var html = "<body style=\"margin:0;\">\n                    <img src=\"" + base64 + "\" style=\"max-width:100%;\"  title=\"(test)\" />\n                </body>";
        var tab = window.open();
        tab.document.write(html);
    }
}
